import ProfitChart from './ProfitChart';

export default ProfitChart;
